export const styles = {
    bold: {
        fontWeight: 600
    },
    addButton: {
        marginLeft: -5
    }
};
